import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { Indexador } from "src/app/model/dominio-operacao.model";
import { Amortizacao, OperacaoCreditoLivre } from "src/app/model/operacao-credito-livre.model";
import { OperacaoGarantida } from "src/app/model/operacao-garantida.model";
import { OperacaoRepasseBndes } from "src/app/model/operacao-repasse-bndes.model";
import { ResultadoPaginado } from "src/app/model/resultado";
import Utils from "src/app/shared/fgi-utils";
import { FileUtilsService } from "src/app/shared/file-utils.service";
import { ModalidadeGarantia } from "../../../model/modalidade_garantia.model";
import { LIMITE_OPERACOES_EXPORTADAS } from "./operacao-garantida.service";

const LIMITE_EXPORTACAO_CSV = LIMITE_OPERACOES_EXPORTADAS;

@Injectable({
    providedIn: 'root'
})
export class BotoesExportacaoOperacaoService {
    private totalResultados: number = 0;
    constructor(
        private fileUtils: FileUtilsService,
        private datePipe: DatePipe,
        private loading: BnLoadingService,
        private bnAlertsService: BnAlertsService
    ) { }

    exportar(nome, csv) {
        if (this.totalResultados > LIMITE_EXPORTACAO_CSV) {
            this.bnAlertsService.alertaAviso('Atenção', 'A exportação está limitada às primeiras 5.000 operações. Utilize os filtros disponíveis para adequar a consulta.');
        }

        this.loading.liberaTela();
        this.fileUtils.exportarArquivo(nome, "\ufeff" + csv, FileUtilsService.TEXT_CSV);
    }

    exportarAditivos(resp: ResultadoPaginado<OperacaoGarantida>) {
        let operacoes = resp?.resultados || null;
        this.totalResultados = resp.totalRegistrosSemPaginacao;

        let csv = "AGENTE FINANCEIRO; ID. OPERACAO CREDITO; ID. ADITIVO; ID. EXT. OPERACAO; DATA DE FORMALIZACAO;DATA DO PROTOCOLO;% DESCONTO ECG;ECG COMPLEMENTAR;ESTADO;MOTIVO\n";
        operacoes.sort((a, b) => Number(a.id) - Number(b.id));

        operacoes.forEach(operacao => {
            const aditivos = operacao?.detalhe?.aditivos || null;

            aditivos?.forEach(aditivo => {
                csv += (operacao?.detalhe?.nomeAgenteFinanceiro || '') + ';'
                    + operacao.id + ';'
                    + aditivo.id + ';'
                    + this.normalizaZerosAEsquerda((operacao as any).ideExternoOperacao) + ';'
                    + this.formatarData(aditivo.dataCelebracaoAditivo) + ';'
                    + this.formatarData(aditivo.dataProtocoloAditivo) + ';'
                    + (aditivo.valorRedutorEcgComplementar > 0 ? this.formatarMoeda(aditivo.valorRedutorEcgComplementar * 100) : '') + ';'
                    + (aditivo.valorEcgComplementar > 0 ? this.formatarMoeda(aditivo.valorEcgComplementar) : '') + ';'
                    + aditivo.detalhe.estado.nomeEstado + ';'
                    + aditivo.detalhe.estado.motivoEstado + '\n';
            });

        });

        this.exportar("aditivos-operacoes-garantidas.csv", csv);
    }

    getNomeModalidade(sigla: string, modalidades: ModalidadeGarantia[]) {
        for (let modalidade of modalidades) {
            if (modalidade.sigla == sigla) {
                return modalidade.nome;
            }
        }
    }

    exportarOperacoes(modalidades: ModalidadeGarantia[], resp: ResultadoPaginado<OperacaoGarantida>) {
        let operacoes = resp?.resultados || null;
        this.totalResultados = resp.totalRegistrosSemPaginacao;

        let csv = 'AGENTE FINANCEIRO;ID. OPERACAO CREDITO;MODALIDADE DE GARANTIA;TIPO DE OPERACAO;MODALIDADE;ID. EXTERNO OPERACAO;DATA DE ENVIO;ESTADO;LIMITE ADICIONAL;'
            + 'DATA DE CONTRATACAO;DATA DA PRIMEIRA LIBERACAO;DATA DE PRIMEIRA AMORTIZACAO;'
            + 'DATA DA ULTIMA AMORTIZACAO;PRAZO CARENCIA;PRAZO AMORTIZACAO;PRAZO TOTAL;VALOR DA OPERACAO; PERCENTUAL GARANTIDO; VALOR GARANTIDO;'
            + 'VALOR DO CREDITO;% DESCONTO ECG;VALOR DO ECG;FATOR K;ECG SOMADO AO VALOR DA OPERACAO;VALOR DA PRIMEIRA LIBERACAO;'
            + 'TAXA DE JUROS (AO ANO);INDEXADOR DA TAXA DE JUROS;PERCENTUAL INDEXADOR;'
            + 'TIPOS DE GARANTIA;MUNICIPIO DO INVESTIMENTO;GARANTIA ATIVA;ESTADO SOLICITACAO HONRA;RETIFICADA;'
            + 'RAZAO SOCIAL DO CLIENTE FINAL;CNPJ CLIENTE FINAL;NATUREZA DA EMPRESA;'
            + 'CNAE;RECEITA BRUTA;TIPO DA RECEITA BRUTA;DATA DA RECEITA BRUTA;TIPO DE LOGRADOURO DA SEDE;LOGRADOURO DA SEDE;'
            + 'NUMERO DO LOGRADOURO;COMPLEMENTO;BAIRRO;CEP;MUNICIPIO DA SEDE;CESTA\n';
            
        console.log("total de operacoes para exportacao: " + operacoes.length);


        operacoes.forEach((operacao) => {
             
        
            const ehCreditoLivre: boolean = operacao.codigoTipoOperacao === 'L';
            const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>operacao;
            const temLiberacoes: boolean = !!operacaoCreditoLivre?.detalhe?.liberacoes?.length;
            const operacaoRepasse: OperacaoRepasseBndes = <OperacaoRepasseBndes>operacao;

            const dataPrimeiraAmortizacao = this.getDataPrimeiraAmortizacao(operacao);
            const dataUltimaAmortizacao = this.getDataUltimaAmortizacao(operacao);   

            csv += this.normalizaTextoCsv(operacao?.detalhe?.nomeAgenteFinanceiro || '') + ';'
                + operacao.id + ';'
                + this.getNomeModalidade(operacao.modalidadeFGI, modalidades) + ';'
                + (ehCreditoLivre ? 'Credito Livre' : 'Repasse BNDES') + ';'
                + (ehCreditoLivre ? operacaoCreditoLivre.modalidade : '') + ';'
                + (this.normalizaZerosAEsquerda(ehCreditoLivre ? operacaoCreditoLivre.idOperacaoAgente : operacaoRepasse.idProtocoloBNDES)) + ';'
                + this.formatarData(operacao.dataEnvio, true) + ';'
                + this.normalizaTextoCsv(operacao?.detalhe?.estado?.nomeEstado || '') + ';'
                + this.normalizaTextoCsv(operacao?.detalhe?.limiteAdicional || '') + ';'
                + this.formatarData(operacao.dataContratacao) + ';'
                + this.formatarData(operacaoCreditoLivre?.detalhe?.liberacoes[0]?.data || null) + ';'
                + this.formatarData(dataPrimeiraAmortizacao) + ';'
                + this.formatarData(dataUltimaAmortizacao) + ';'
                + (operacao.detalhe?.prazoCarenciaContratualEmMeses || '') + ';'
                + (operacao.detalhe?.prazoAmortizacaoContratualEmMeses || '') + ';'
                + (operacao.detalhe?.prazoContratualEmMeses || '') + ';'
                + this.formatarMoeda(operacao.valorOperacao) + ';'
                + operacao.percentualGarantido + '%;'
                + this.formatarMoeda(operacao.detalhe.valorGarantido) + ';'
                + this.formatarMoeda(operacao.detalhe.valorCredito) + ';'
                + (operacao.detalhe.valorRedutorEcg > 0 ? this.formatarMoeda(operacao.detalhe.valorRedutorEcg * 100) : '') + ';' // % DESCONTO ECG
                + this.formatarMoeda(operacao.detalhe.valorEcg) + ';'
                + operacao.detalhe.fatorK + ';'
                + (this.ecgDeveSerSomadoAoValorOperacao(operacao) ? 'Sim' : 'Nao') + ';'
                + this.formatarMoeda(operacaoCreditoLivre?.detalhe?.liberacoes[0]?.valor) + ';'
                + (ehCreditoLivre ? operacaoCreditoLivre.taxaEfetivaAnual : '') + ';'
                + (ehCreditoLivre ? operacaoCreditoLivre.detalheCreditoLivre.nomeIndexadorTaxaJuros : '') + ';'
                + (ehCreditoLivre ? operacaoCreditoLivre.percentualIndexador : '') + ';'
                + (ehCreditoLivre ? this.tiposGarantiaStr(operacaoCreditoLivre) : '') + ';'
                + (ehCreditoLivre ? operacaoCreditoLivre.detalheCreditoLivre.nomeMunicipioInvestimento : '') + ';'
                + (operacao.detalhe.garantiaAtiva == 'S' ? 'Sim' : 'Nao') + ';'
                + operacao.detalhe.estadoSolicitacaoHonraAtual.nomeEstado + ';'
                + (operacao.detalhe.retificada == 'S' ? 'Sim' : 'Nao') + ';'
                + (ehCreditoLivre ? this.normalizaTextoCsv(operacaoCreditoLivre.razaoSocialClienteFinal) : '') + ';'
                + this.normalizaTextoCsv(operacao.cnpjClienteFinal) + ';'
                + this.normalizaTextoCsv(ehCreditoLivre ? operacaoCreditoLivre.detalheCreditoLivre.nomeNaturezaClienteFinal : '') + ';'
                + this.normalizaTextoCsv(operacao.detalhe.nomeCnaeClienteFinal) + ';'
                + this.formatarMoeda(operacao.receitaBrutaClienteFinal) + ';'
                + this.normalizaTextoCsv(operacao.tipoReceitaBruta || '') + ';'
                + this.formatarData(operacao.dataReferenciaReceitaBruta) + ';'
                + (ehCreditoLivre ? this.normalizaTextoCsv(operacaoCreditoLivre.enderecoSedeClienteFinal.nomeTipoLogradouro) : '') + ';'
                + (ehCreditoLivre ? this.normalizaTextoCsv(operacaoCreditoLivre.enderecoSedeClienteFinal.nomeLogradouro) : '') + ';'
                + (ehCreditoLivre ? this.normalizaTextoCsv(operacaoCreditoLivre.enderecoSedeClienteFinal.numeroLogradouro) : '') + ';'
                + (ehCreditoLivre ? this.normalizaTextoCsv(operacaoCreditoLivre.enderecoSedeClienteFinal.complemento) || '' : '') + ';'
                + (ehCreditoLivre ? this.normalizaTextoCsv(operacaoCreditoLivre.enderecoSedeClienteFinal.nomeBairro) : '') + ';'
                + (ehCreditoLivre ? this.normalizaTextoCsv(operacaoCreditoLivre.enderecoSedeClienteFinal.cep) : '') + ';'
                + (ehCreditoLivre ? this.normalizaTextoCsv(operacaoCreditoLivre.enderecoSedeClienteFinal.nomeMunicipio) : '') + ';'
                + (operacao.detalhe.numeroTranche) + '\n';


        });

        this.exportar('operacoes-garantidas.csv', csv);
    }

    exportarLiberacoes(resp: ResultadoPaginado<OperacaoGarantida>) {
        let operacoes = resp?.resultados || null;
        this.totalResultados = resp.totalRegistrosSemPaginacao;

        let csv = 'AGENTE FINANCEIRO;ID. LIBERACAO;ID. OPERACAO CREDITO; ID. EXTERNO OPERACAO;'
            + 'NUMERO DA LIBERACAO;DATA DA LIBERACAO;VALOR DA LIBERACAO;% DESCONTO ECG;VALOR DO ECG;ESTADO\n';

        operacoes.forEach(operacao => {

            const liberacoes = operacao?.detalhe?.liberacoes || null;

            liberacoes?.forEach(liberacao => {

                csv += (operacao?.detalhe?.nomeAgenteFinanceiro || '') + ';'
                    + liberacao.id + ';'
                    + operacao.id + ';'
                    + this.normalizaZerosAEsquerda(this.normalizaTextoCsv(this.getIdExternoOperacao(operacao))) + ';'
                    + liberacao.numero + ';'
                    + this.formatarData(liberacao.data) + ';'
                    + this.formatarMoeda(liberacao.valor) + ';'
                    + (liberacao.valorRedutorEcg > 0 ? this.formatarMoeda(liberacao.valorRedutorEcg * 100) : '') + ';' //% DESCONTO ECG
                    + this.formatarMoeda(liberacao.valorEcg) + ';'
                    + this.normalizaTextoCsv(liberacao?.estadoDTO?.nomeEstado || '') + '\n';
            });

        });

        this.exportar('liberacoes-garantidas.csv', csv);
    }

    exportarAmortizacoes(resp: ResultadoPaginado<OperacaoGarantida>) {
        let operacoes = resp?.resultados || null;
        this.totalResultados = resp.totalRegistrosSemPaginacao;

        let csv = 'AGENTE FINANCEIRO;ID. OPERACAO CREDITO; ID. EXTERNO OPERACAO;'
            + 'DATA DA AMORTIZACAO;VALOR DA AMORTIZACAO;SALDO DEVEDOR APOS AMORTIZACAO\n';

        operacoes?.forEach(operacao => {
            const operacaoCreditoLivre = <OperacaoCreditoLivre>operacao;
            let saldoDevedor = this.totalizaLiberacoes(<OperacaoCreditoLivre>operacao);
            this.trataAmortizacoes(operacaoCreditoLivre);

            const amortizacoes = operacaoCreditoLivre?.amortizacoes || null;
            amortizacoes?.forEach(amortizacao => {
                saldoDevedor -= amortizacao.valor;
                csv += (operacao?.detalhe?.nomeAgenteFinanceiro || '') + ';'
                    + operacao.id + ';'
                    + this.normalizaZerosAEsquerda(this.normalizaTextoCsv(this.getIdExternoOperacao(operacao))) + ';'
                    + this.formatarData(amortizacao?.data) + this.trataTextoAntecipada(amortizacao) + ';'
                    + this.formatarMoeda(amortizacao.valor) + ';'
                    + this.formatarMoeda(saldoDevedor) + '\n'

            });

        });

        this.exportar('amortizacoes-garantidas.csv', csv);
    }

    private trataTextoAntecipada(amortizacao: Amortizacao) {
        if (amortizacao?.antecipada) {
            return '(antecipada)';
        }
        return '';
    }

    public totalizaLiberacoes(operacao: OperacaoCreditoLivre) {
        let total: number = operacao.detalhe.liberacoes
            .map(item => Number(item.valor))
            .reduce((acumulado, v) => acumulado + v, 0);
        if (operacao.detalhe.ecgDeveSerSomadoAoValorOperacao === 'S') {
            total += operacao.detalhe.liberacoes
                .map(item => Number(item.valorEcg))
                .reduce((acumuladoEcg, v) => acumuladoEcg + v, 0);
        }
        return total;
    }

    private trataAmortizacoes(operacao: OperacaoCreditoLivre): void {
        if (!operacao.amortizacoesAntecipadas || operacao.amortizacoesAntecipadas.length == 0) {
            return;
        } else {
            console.log(operacao);
        }

        operacao.amortizacoes =
            operacao.
                amortizacoesAntecipadas
                .map(a => {
                    a.antecipada = true;
                    return a;
                })
                .concat(operacao.amortizacoes)
                .map(a => {
                    a?.data ? a.data = this._ajustaCampoDate(a.data) : null;
                    return a;
                }).sort((a1, a2) => {
                    return a1?.data?.getTime() - a2?.data?.getTime();
                });

    }

    private getIdExternoOperacao(operacao: OperacaoGarantida) {
        return operacao.codigoTipoOperacao == 'L' ? (<OperacaoCreditoLivre>operacao).idOperacaoAgente : (<OperacaoRepasseBndes>operacao).idProtocoloBNDES;
    }

    private _ajustaCampoDate(data: any) {
        if (typeof data === 'string') {
            if (data.length == 10) {
                data += ' 00:00:00';
            }
            return new Date(data);
        }
        return data;
    }

    formatarData(data, comHora?) {
        const hora = comHora ? 'HH:mm:ss' : '';
        return data ? this.datePipe.transform(data, 'dd/MM/yyyy ' + hora) : '';
    }

    formatarMoeda(moeda) {
        if (!isNaN(moeda)) {
            return Number(moeda).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        }
        return '';
    }

    private getDataUltimaAmortizacao(operacao: OperacaoGarantida): Date {
        if (operacao.codigoTipoOperacao == 'R') {
            const operacaoRepasse: OperacaoRepasseBndes = <OperacaoRepasseBndes>operacao;
            return operacaoRepasse.dataUltimaAmortizacao;
        }
        else {
            const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>operacao;
            return operacaoCreditoLivre.amortizacoes && operacaoCreditoLivre.amortizacoes[operacaoCreditoLivre.amortizacoes.length - 1] ?
                operacaoCreditoLivre.amortizacoes[operacaoCreditoLivre.amortizacoes.length - 1].data : undefined;
        }
    }

    private getDataPrimeiraAmortizacao(operacao: OperacaoGarantida): Date {
        if (operacao.codigoTipoOperacao == 'R') {
            const operacaoRepasse: OperacaoRepasseBndes = <OperacaoRepasseBndes>operacao;
            return operacaoRepasse.dataPrimeiraAmortizacao;
        }
        else {
            const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>operacao;
            return operacaoCreditoLivre.amortizacoes && operacaoCreditoLivre.amortizacoes[0] ? operacaoCreditoLivre.amortizacoes[0].data : undefined;
        }
    }


    private ecgDeveSerSomadoAoValorOperacao(operacao: OperacaoGarantida) {
        return operacao.detalhe.ecgDeveSerSomadoAoValorOperacao == 'S';
    }

    private tiposGarantiaStr(operacaoCreditoLivre: OperacaoCreditoLivre): string {
        let result = [];
        if (operacaoCreditoLivre.outrasGarantias) {
            for (let outraGarantia of operacaoCreditoLivre.outrasGarantias) {
                result.push(outraGarantia.tipoGarantia);
            }
        }
        return result.join(',');
    }

    private normalizaTextoCsv(linha: string) {
        return Utils.normalizaTextoParaCsv(linha);
    }

    private normalizaZerosAEsquerda(linha: string) {
        return Utils.formataZerosAEsquerda(linha);
    }


}